import React, { useContext } from "react";
// material-ui
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

// core components
import Box from "@material-ui/core/Box";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle";
// @material-ui/icons
// core components
import radioStyles from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.js";

import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import CustomInput from "components/CustomInput/CustomInput";
import Hint from "components/Hint/Hint";
import Paragraph from "components/Paragraph/Paragraph";
import { TestContext } from "contexts/TestContext";
import 'katex/dist/katex.min.css';
import ReactHtmlParser from "react-html-parser";
import Latex from 'react-latex-next';
{/* latex CSS */ }

var styles = {
    ...dashboardStyle,
    ...loginPageStyle,
    ...radioStyles,
    cardTitle: {
        marginTop: "0",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
    },
};

const useStyles = makeStyles(styles);

export default function NumericalChoiceQuestion({ question, contentType, updateQuestion, preview, qnoes }) {
    const { test } = useContext(TestContext);
    console.log("question123", question);

    const [selectedEnabled, setSelectedEnabled] = React.useState('');
    const handleCheck = (x) => {

        setSelectedEnabled(x.target.value);
        console.log(x, 'handledX123')
        question.response = x.target.value;
        question.isCorrect = x.target.value == question.answer;
    };

    React.useEffect(() => {
        //needs to be clear to avoid retaining of options
        if (question.response) {
            setSelectedEnabled(question.response)
        } else {
            setSelectedEnabled('')
        }

        // setSelectedEnabled(question.response);
    }, [question]);

    const classes = useStyles();

    return (
        <div style={{ width: "100%" }}>
            <Box display="flex" p={2}>
                <Box p={2} sx={{ width: "100%" }}>
                    <Box display="flex" p={1} style={{ padding: 0 }}>
                        <Box p={1} style={{ width: '8%', padding: 0, color: 'black', fontSize: '20px' }}>
                            <div style={{ float: 'left', marginRight: '5px', fontSize: '21px' }}> Q {qnoes}. </div>
                        </Box>
                        <Box p={1} flexGrow={1} style={{ padding: 0, color: 'black', fontSize: '20px' }}>
                            {
                                question && question.text && question.text.length > 0 ? (
                                    contentType === 1 ?
                                        <div >{question?.text}</div>
                                        : contentType === 3 ?
                                            <Latex >{question?.text}</Latex>
                                            : contentType === 4 ?
                                                <div>{question.text && ReactHtmlParser(question.text)}</div>
                                                :
                                                <div style={{ marginBottom: '10px' }}>{question.text}</div>
                                ) : null
                            }
                            {/* <div style={{color:'black',fontSize:'20px'}}>{question.text && ReactHtmlParser(question.text)}</div> */}
                            {/* <Box p={2} > */}
                            <Box p={1} >
                                {question.image && <img src={question.image} alt="..." />}
                            </Box>
                            {/* </Box> */}
                        </Box>

                        <Box p={1}>
                            {(question?.paragraphImage != null || question?.paragraphText != null)

                                ? (
                                    <Paragraph messageImage={question?.paragraphImage} messageText={question?.paragraphText} questionId={question.id} />
                                ) : null}
                            {test && test.showHint == 2 ? null : (
                                <Hint message={question.hint} ContentType={contentType} questionId={question.id} />
                            )}
                        </Box>
                    </Box>
                    {
                        console.log(question?.options["$values"], 'questionOptions1234')
                    }
                    {
                        question && contentType === 3 || 1 ?
                            <GridContainer alignItems="center" spacing={1}>
                                <GridItem xs={11} sm={11} md={3}>
                                    <CustomInput
                                        labelText={<span> Type your answer</span>}
                                        id="response"
                                        formControlProps={{
                                            fullWidth: false,
                                        }}
                                        inputProps={{
                                            name: 'response',
                                            onChange: (x) => handleCheck(x),
                                            value: selectedEnabled
                                        }}
                                        disabled={false}
                                    />
                                </GridItem>
                                <GridItem xs={11} sm={11} md={3}>
                                    <div
                                        className={
                                            classes.checkboxAndRadio +
                                            " " +
                                            classes.checkboxAndRadioHorizontal
                                        }
                                    >

                                        {
                                            preview == true ?
                                                <>
                                                    <CustomInput
                                                        labelText={<span> Correct Answer</span>}
                                                        id="choiceId01"
                                                        formControlProps={{
                                                            fullWidth: false,
                                                        }}
                                                        inputProps={{
                                                            name: 'choiceId01',
                                                            onChange: (x) => handleCheck(x),
                                                            type: "number",
                                                            value:
                                                                // model.questionChoices &&
                                                                //     model.questionChoices["$values"][0]["choiceId01"]
                                                                //     ? model.questionChoices["$values"][0]["choiceId01"]
                                                                //     : "",
                                                                question.answer
                                                        }}
                                                        disabled={true}
                                                    />
                                                    {
                                                        (question.isSubmitted == true || preview == true) && question.answer ?
                                                            <CheckIcon style={{ color: "green" }} /> :
                                                            null
                                                    }
                                                    {question.isSubmitted == true &&
                                                        question.isCorrect == false &&
                                                        selectedEnabled === question.answer ? (
                                                        // <GridItem xs={11} sm={11} md={6}>
                                                        <CloseIcon style={{ color: "red" }} />
                                                        // </GridItem>
                                                    ) : null}
                                                </>
                                                : null
                                        }
                                    </div>
                                </GridItem>

                            </GridContainer>
                            // ))
                            : null
                    }
                </Box>
            </Box>
        </div>
    );
}
